import { connect } from 'react-redux'
import _ from "lodash";

import { fetchPreviewAsset } from 'src/legacy/redux/actions/assets.jsx';
import { fetchConversation, fetchShareAssets, fetchShareRecipients } from 'src/legacy/redux/actions/conversations';

import SharesView from './view';

const mapStateToProps = (state,ownProps) => {
  var id = _.get(ownProps, "id", null); 
  
  const shares = _.get(state.legacyRootReducer, 'conversations.items', []);
  var share = shares.find(item => item.id == id);

  const conversation = _.get(state.legacyRootReducer, `conversations.conversation.item[${id}]`);
  return {
    id: id,
    share: share,
    user: state.users.me,
    conversation: conversation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPreviewAsset: (assetID) => {
      return dispatch(fetchPreviewAsset(assetID));
    },

    fetchShare: (id) => {
      return dispatch(fetchConversation(id));
    },

    fetchShareAssets: (id) => {
      return dispatch(fetchShareAssets(id));
    },

    fetchShareRecipients: (id, page) => {
      return dispatch(fetchShareRecipients(id, page));
    },
  }
}

const SharesViewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SharesView)

export default SharesViewContainer;